module.exports = __webpack_public_path__ + "img/jskf.8c16da19.png";